import type { VariableScope } from "src/formkit/components/types";

import { journeyVariableOptions } from "src/formkit/components/mapper-v2/variable-options";

const journeyVariableLabel = (variable: string): string | undefined =>
  journeyVariableOptions.find((option) => option.variable === variable)?.label;

// Journey tiles call this source a journey value and name each one by its label, as the tile summaries do.
export const variableMappingLabel = (scope: VariableScope): string =>
  scope === "realtime-journey" ? "Journey value" : "Variable value";

export const variableValueLabel = ({
  scope,
  variable,
}: {
  scope: VariableScope;
  variable: string;
}): string =>
  (scope === "realtime-journey" ? journeyVariableLabel(variable) : undefined) ??
  variable;
